/**
 * Признак «страницу сворачивают или закрывают».
 *
 * Нужен ровно одному потребителю — фильтру шума в Sentry (см. lib/sentry). В момент ухода
 * со страницы браузер обрывает все текущие запросы и незавершённые import(), и приложение
 * получает пачку ошибок, которых на живой странице не было бы.
 *
 * Слушаем visibilitychange, а не только pagehide: на мобильных (в том числе в webview 2ГИС)
 * переход в фон и закрытие вкладки дают hidden, а pagehide приходит не всегда и позже.
 * Возврат на страницу снимает признак: bfcache отдаёт ту же страницу живой.
 */

let isHidden = typeof document !== "undefined" && document.visibilityState === "hidden";

if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", () => {
    isHidden = document.visibilityState === "hidden";
  });
}

if (typeof window !== "undefined") {
  window.addEventListener("pagehide", () => {
    isHidden = true;
  });
  window.addEventListener("pageshow", () => {
    isHidden = false;
  });
}

/** true — страница не на экране: текущие запросы и импорты могут быть оборваны браузером. */
export const isPageHidden = (): boolean => isHidden;
